import {RegionType} from "../../region/types/RegionType";
import {IRecentFilter} from "../../search/utils/recent_filters_storage";
import {IPersonalizedHomepageBackgroundImages} from "../components/PersonalizedHomepage/PersonalizedHomepageHero";
import {PERSONALIZED_HERO_CITY_BACKGROUNDS, PERSONALIZED_HERO_DEFAULT_BACKGROUNDS} from "../constants/personalized_hero_city_backgrounds";

const POLISH_CHARACTERS_MAP: Record<string, string> = {ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z"};

export const getHeroCitySlug = (cityName: string): string =>
    cityName
        .toLocaleLowerCase("pl-PL")
        .replace(/[ąćęłńóśźż]/g, (character) => POLISH_CHARACTERS_MAP[character] ?? character)
        .replace(/\s+/g, "-");

/** City of the newest search — the city itself, or the parent city when the search targets a district. */
export const getHeroCityNameFromRecentFilters = (recentFilters: IRecentFilter[]): string | undefined => {
    const region = recentFilters[0]?.search?.regions?.[0];

    if (!region) {
        return undefined;
    }

    if (region.type === RegionType.CITY) {
        return region.name;
    }

    return region.parent?.name ?? region.name;
};

/**
 * Cityscape matching the searched city. Anything else — no history, or a city
 * outside the covered set — gets a neutral photo (deterministic per key, so the
 * hero stays stable between visits) instead of a wrong city's skyline.
 */
export const getPersonalizedHeroBackground = (personalizationKey?: string): IPersonalizedHomepageBackgroundImages => {
    if (personalizationKey) {
        const cityBackground = PERSONALIZED_HERO_CITY_BACKGROUNDS[getHeroCitySlug(personalizationKey)];

        if (cityBackground) {
            return cityBackground;
        }
    }

    const hash = Array.from(personalizationKey ?? "").reduce((result, character) => (result * 31 + (character.codePointAt(0) ?? 0)) >>> 0, 0);

    return PERSONALIZED_HERO_DEFAULT_BACKGROUNDS[hash % PERSONALIZED_HERO_DEFAULT_BACKGROUNDS.length];
};
import {RegionType} from "../../region/types/RegionType";
import {IRecentFilter} from "../../search/utils/recent_filters_storage";
import {IPersonalizedHomepageBackgroundImages} from "../components/PersonalizedHomepage/PersonalizedHomepageHero";
import {PERSONALIZED_HERO_CITY_BACKGROUNDS, PERSONALIZED_HERO_DEFAULT_BACKGROUNDS} from "../constants/personalized_hero_city_backgrounds";

const POLISH_CHARACTERS_MAP: Record<string, string> = {ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z"};

export const getHeroCitySlug = (cityName: string): string =>
    cityName
        .toLocaleLowerCase("pl-PL")
        .replace(/[ąćęłńóśźż]/g, (character) => POLISH_CHARACTERS_MAP[character] ?? character)
        .replace(/\s+/g, "-");

/** City of the newest search — the city itself, or the parent city when the search targets a district. */
export const getHeroCityNameFromRecentFilters = (recentFilters: IRecentFilter[]): string | undefined => {
    const region = recentFilters[0]?.search?.regions?.[0];

    if (!region) {
        return undefined;
    }

    if (region.type === RegionType.CITY) {
        return region.name;
    }

    return region.parent?.name ?? region.name;
};

/**
 * Cityscape matching the searched city. Anything else — no history, or a city
 * outside the covered set — gets a neutral photo (deterministic per key, so the
 * hero stays stable between visits) instead of a wrong city's skyline.
 */
export const getPersonalizedHeroBackground = (personalizationKey?: string): IPersonalizedHomepageBackgroundImages => {
    if (personalizationKey) {
        const cityBackground = PERSONALIZED_HERO_CITY_BACKGROUNDS[getHeroCitySlug(personalizationKey)];

        if (cityBackground) {
            return cityBackground;
        }
    }

    const hash = Array.from(personalizationKey ?? "").reduce((result, character) => (result * 31 + (character.codePointAt(0) ?? 0)) >>> 0, 0);

    return PERSONALIZED_HERO_DEFAULT_BACKGROUNDS[hash % PERSONALIZED_HERO_DEFAULT_BACKGROUNDS.length];
};
